var map = {
	"./hht1_ep5_minisitcom_01.png": 361,
	"./hht1_ep5_minisitcom_02.png": 362,
	"./hht1_ep5_minisitcom_03.png": 363,
	"./hht1_ep5_minisitcom_04.png": 364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 360;